<template>
  <b-dropdown
    id="unduh-dropdown"
    ref="downloadDropdown"
    right
    variant="primary"
    menu-class="dropdown-menu-end download-confirmation-menu"
    no-close-on-click
    @hide="resetSelectedItem"
  >
    <template #button-content>
      <i class="mc-fa icon-outline_download"></i>{{ $t('global.action.download') }}
    </template>

    <template v-if="!showDownloadConfirmation">
      <button
        v-for="item of items"
        :key="item.name"
        type="button"
        class="dropdown-item"
        @click.stop="selectItem(item)"
      >
        <img :src="item.icon" :alt="item.name" />
        {{ item.label }}
      </button>
    </template>

    <div v-else class="download-confirmation" @click.stop>
      <p class="download-confirmation__message">
        {{ $t('report.text.tooBigReport') }}
      </p>
      <div class="download-confirmation__actions">
        <button type="button" class="btn btn-light btn-sm" @click="resetSelectedItem">
          {{ $t('global.action.cancel') }}
        </button>
        <button type="button" class="btn btn-primary btn-sm" @click="confirmDownload">
          {{ $t('global.action.download') }}
        </button>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    report: {
      required: true,
      type: Object,
    },
    items: {
      required: true,
      type: Array,
    },
    actualTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedItem: null,
      maxPdf: 5000,
      maxExcel: 10000,
      isHugeReport: false,
    }
  },
  computed: {
    showDownloadConfirmation() {
      return this.selectedItem && this.isHugeReport
    },
  },
  methods: {
    isHugeReportItem(item) {
      if (item.name == 'pdf') return this.actualTotal > this.maxPdf
      if (item.name == 'excel') return this.actualTotal > this.maxExcel
      return false
    },
    selectItem(item) {
      this.isHugeReport = this.isHugeReportItem(item)

      if (this.isHugeReport) {
        this.selectedItem = item
      } else {
        this.selectedItem = null
        item.onClick()
        this.$refs.downloadDropdown.hide(true)
      }
    },
    resetSelectedItem() {
      this.selectedItem = null
    },
    confirmDownload() {
      if (!this.selectedItem) return

      this.selectedItem.onClick()
      this.$refs.downloadDropdown.hide(true)
    },
  },
}
</script>

<style scoped>
::v-deep .download-confirmation-menu {
  min-width: 228px;
}

.download-confirmation {
  width: 228px;
  padding: 12px;
}

.download-confirmation__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  color: #1f2a44;
  font-size: 14px;
  font-weight: 600;
}

.download-confirmation__header i {
  color: #f59e0b;
  font-size: 16px;
}

.download-confirmation__message {
  margin: 0 0 12px;
  color: #5f6b7a;
  font-size: 12px;
  line-height: 1.4;
}

.download-confirmation__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
